import React, { ReactElement, useState, useLayoutEffect } from 'react';

import { FONT_SIZES } from '~/constants/typography';
import Gap from '~/components/flow/Gap';
import Break from '~/components/flow/Break';

import { Charts, Sounds, Beat } from '../../../../models';
import { BEAT } from '../../../../constants/defaults';
import Script from '../../../../components/Script';
import Controls from '../../../../components/Controls';
import Visualize from '../../../../components/Visualize';

interface ExerciseProps {
  sounds?: Sounds;
  beat: Beat;
}

function Exercise({ sounds, beat }: ExerciseProps): ReactElement {
  const [internal, setInternal] = useState(BEAT);
  const [charts, setCharts] = useState<Charts>({});
  const [progress, setProgress] = useState(0);
  const [loaded, setLoaded] = useState<Beat>();
  const [hidden, setHidden] = useState(true);
  const state = sounds ? 'ready' : 'loading';

  useLayoutEffect(() => {
    if (sounds) setLoaded(beat);
  }, [sounds]);

  // Styling
  const exerciseStyle = {
    width: '100%',
    fontSize: FONT_SIZES.text,
    textAlign: 'center' as const,
  };
  const scriptWrapperStyle = {
    display: hidden ? 'none' : 'block',
  };

  return (
    <div style={exerciseStyle}>
      <Visualize
        beat={internal}
        charts={charts}
        state={state}
        progress={progress}
      />
      <Gap />
      <Controls
        beat={internal}
        setBeat={setInternal}
        charts={charts}
        setProgress={setProgress}
        disabled={!sounds}
        hidden={hidden}
        setHidden={setHidden}
        loaded={loaded}
      />
      <Break />
      <div style={scriptWrapperStyle}>
        <Script
          sounds={sounds}
          beat={internal}
          setBeat={setInternal}
          setCharts={setCharts}
          disabled={!sounds}
          loaded={loaded}
        />
      </div>
    </div>
  );
}

export default Exercise;
